module.exports = __webpack_public_path__ + "static/media/Decisions_Step5_Image19.0d416200.jpg";